<template>
    <div class="searchProductName">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane :label="categoryItem.categoryName" v-for="(categoryItem,index) in washProductCategoryList"
                         :key="categoryItem.id" :name="categoryItem.id">
                <div class="product-item" v-for="(productItem,index) in washProductList" :key="index" @click="onProduct(productItem)">
                    <img :src="productItem.productPic">
                    {{ productItem.productName }}
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import { get, postJson, post } from '@/utils/request.js';

export default {
    data() {
        return {
            activeName: null,
            washProductCategoryList: [],
            washProductList: []
        };
    },
    mounted() {
        this.getWashProductCategory();
    },
    methods: {
        // 切换事件
        handleClick(tab, event) {
            this.getWashProductList(tab.name);
        },

        // 获取分类
        getWashProductCategory() {
            get('/wash/utils/findAllWashProductCategory').then((res) => {
                if (res.success) {
                    this.washProductCategoryList = res.list;
                    if (res.list.length > 0) {
                        this.activeName = res.list[0].id;
                        this.getWashProductList(res.list[0].id);
                    }
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },

        // 获取商品
        getWashProductList(categoryId) {
            get('/wash/utils/findAllWashProduct', { categoryId }).then((res) => {
                if (res.success) {
                    this.washProductList = res.list;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                    s;
                }
            });
        },

        // 点击了一项
        onProduct(productItem) {
            this.$emit('onProduct', productItem);
        },
    }
};
</script>

<style scoped lang="scss">
.searchProductName {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
}

.product-item{
    display: inline-block;
    margin:  0 0 10px 10px;
    padding: 12px 20px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;

    img{
        display: inline-block;
        width: 45px;
        height: 45px;
    }
}

::v-deep .el-tabs__item {
    font-size: 16px;
}
</style>